<div id="wrapper">
    <div>
        <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
    </div>
    <div>
        <app-tab-nav [visible]="false" (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event" (updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event" (updateCurrentList)="this.currentList=$event"
            (updateSelectBan)="this.selectBan=$event" (updateInitializeData)="this.initializeData()">
        </app-tab-nav>
    </div>
    <div class="allcont logsize m-top-i">
        <div class="basicrow roboto-r f-reg f-black m-top m-bott">
            <div class="container padding-bottom">
                <div class="basicrow ">
                    <div class="fulltitle  f-btitle autodef">
                        <span class="icon-dash-01"></span> Términos y Condiciones Netflix
                    </div>
                </div>
                <app-collapse  [(content)]="this.content"></app-collapse>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>